module.exports = require("./dist/jquery.js");


//////////////////
// WEBPACK FOOTER
// jquery (bower component)
// module id = 93
// module chunks = 1